var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-cart",
    x: 0,
    y: 0.002,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-cart1",
    serifid: "iconB-cart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.855,4.543c0.29,-0 15.95,-0 15.95,-0c0.653,-0.001 1.246,0.62 1.246,1.238c-0,0.011 -0.004,5.502 -0.004,7.131c0,1.045 -0.869,1.287 -1.118,1.352c-0.002,0 -0.004,0.001 -0.006,0.001c0,0 -10.854,2.687 -11.732,2.888c-0.221,0.051 -0.382,0.014 -0.426,0.008c-0.512,-0.081 -0.701,-0.523 -0.729,-0.583c-0.161,-0.355 -4.772,-10.061 -5.337,-11.599c-0.473,-0.003 -1.731,-0.01 -1.734,-0.01c-1.3,0 -1.27,-1.968 0,-1.968c0.482,0 2.639,0.012 2.639,0.012c0,0 0.688,-0.004 0.933,0.666c0.205,0.559 0.263,0.716 0.318,0.864Zm15.193,1.964c-0,0 -14.48,0.007 -14.48,0.006c0.513,1.379 3.283,7.128 3.836,8.272c0.043,0.09 0.073,0.152 0.087,0.18l10.557,-2.532c0,-0 -0,-5.926 -0,-5.926Zm-15.048,10.494c1.104,-0 2,0.896 2,2c0,1.104 -0.896,2 -2,2c-1.104,-0 -2,-0.896 -2,-2c0,-1.104 0.896,-2 2,-2Zm11.735,-0c1.104,-0 2,0.896 2,2c-0,1.104 -0.896,2 -2,2c-1.104,-0 -2,-0.896 -2,-2c-0,-1.104 0.896,-2 2,-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCart);
export default __webpack_public_path__ + "static/media/iconB-cart.5e55e331958dfe5fb9f6596e5a8b1c02.svg";
export { ForwardRef as ReactComponent };